import React from 'react';
import Page from '../../components/Page/Page';
import seo from '../../constants/seo';

const Guide = () => (
  <Page {...seo.guide}>
    <h2 className="mt-0 pt-0">TREKKING GUIDES</h2>
    <p className="mb-1">Namaste,</p>
    <p>
      We understand that given your experience and expertise, you deserve to get paid more.
      We also understand that you wish to get some type of payment confirmation from the
      bookings you get through social media. HoneyGuide can help you achieve your goals.
    </p>
    <p>
      If you are a Trekking Guide working in the Himalayas, joining HoneyGuide will help
      you:
      <ol>
        <li>Sell your own Treks and Increase your Income.</li>
        <li>Get Online Payments from Trekkers.</li>
        <li>Manage your Online Professional Profile with Reviews and Ratings.</li>
      </ol>
    </p>
    <p>
      Some of the key features of working with HoneyGuide are:
      <ol>
        <li>Select your own Daily Wages.</li>
        <li>
          Flat 12 percent Service Fee. Increase in margins from larger groups is all yours.
        </li>
        <li>30 day Refund Period will protect you from last minute cancellations.</li>
        <li>Free and Offline “Trekking in Nepal” mobile app to help you.</li>
      </ol>
    </p>
    <p>
      HoneyGuide is already working with 100+ lodges in Everest, 35+ Guides, and 1 Airline.
      Join the growing fraternity of trekking guides:
    </p>
    <p>
      If you have any questions, please contact: <br />
      Ashish Shrestha <br />
      +977-9841370673 <br />
      <a href="mailto:honeyhunter@honeyguideapps.com">honeyhunter@honeyguideapps.com</a>
    </p>
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSdEui3Z-bShmLGRSPqMv5IZkEGPq-Djx3Qv763D4iMpj68Xhw/viewform?embedded=true"
      width="100%"
      height="938"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Guide"
    >
      Loading...
    </iframe>

    <p>
      <strong>About HoneyGuide</strong> <br />
      HoneyGuide is a technology company that helps men and mountains meet more often. While
      we go about it, we are constantly guided by our belief that:
      <ol>
        <li>
          Providing Trekkers with No-strings attached and Accurate Information will make our
          mountains safer and help more people enjoy the thrills of a rarefied atmosphere.
        </li>
        <li>A Trekker should have the power to run a trek the way she sees fit easily.</li>
        <li>
          Connecting Local Service Providers with Trekkers will lead to a more equitable
          distribution of tourism dividends and increase service levels faster.
        </li>
      </ol>
    </p>
  </Page>
);

export default Guide;



// WEBPACK FOOTER //
// ./src/screens/Partners/Guide.jsx